import React from 'react';
import {
  Search,
  User,
  HandCoins,
  MessageCircle,
  Monitor,
  Settings,
  Glasses,
  Paintbrush,
  Rotate3D,
  HelpCircle,
  ArrowBigRight,
  DollarSign,
  Tag,
  Gift,
  ChartCandlestick,
  CodeXml, CirclePercent, Rocket,
  ChartPie, BadgeIndianRupee,
  Bot, CircleCheckBig, DraftingCompass
} from 'lucide-react';
import { FaRobot, FaListAlt, FaComments, FaThumbsUp } from 'react-icons/fa';
import { Typewriter } from 'react-simple-typewriter';
import Layout from '../../components/layout';
import { Link } from 'react-router-dom';
import { IoRocketSharp } from "react-icons/io5";
import { FaCommentDots, FaChartLine, FaGlobe, FaSearch, FaTools, FaFileAlt, FaSmile, FaWhatsapp, FaShieldAlt, FaHandsHelping, FaShoppingCart, FaChartBar, FaCogs, FaMobileAlt, FaChartPie } from 'react-icons/fa';
import { MdWidgets } from 'react-icons/md';
import { MdPhoneIphone, MdAndroid } from 'react-icons/md';
import { FaUserFriends } from 'react-icons/fa';
import { TextGenerateEffect } from '../../components/ui/text-generate-effect';

const features = [
  { label: "Automate personalized campaigns across WhatsApp and web", passed: true },
  { label: "Reach customers on their preferred channels effortlessly", passed: true },
  { label: "Send timely, contextual messages that drive engagement", passed: false },
  { label: "Boost marketing impact with smart, automated delivery", passed: true },
  { label: "Maximize customer interaction with cross-platform reach", passed: true },
  // { label: "Content-based filtering", passed: true },
];

const ZeroClick = () => {
  return (
    <Layout>
      <div className="bg-white text-gray-800 font-sans min-h-screen">
        <Hero />
        <WhyZeroClick2 />
        {/* <WhyZeroClick /> */}
        <WhatsApp />
        {/* <CoreModulesCapabilities /> */}
        <CoreModulesCapabilities2 />
        <UseCases />
        <MarketPlace />
        <Benefits />

        <RequestDemo />
      </div>
    </Layout>
  );
};

export default ZeroClick;

const MarketPlace = () => (
  <section className="py-16 bg-white text-[#301407] px-16">
    <h2 className='text-4xl font-bold mb-12 text-center'>Who should use it?
    </h2>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row md:items-start gap-12">
      <div className="md:w-1/2">
        <h2 className="text-3xl font-bold leading-tight mb-4">Seamlessly connect across channels, powered by one intelligent core.

        </h2>
        <p className="text-gray-700 mb-6 mt-2">
          One engine | Every conversation | Anywhere
        </p>
        {/* <TextGenerateEffect duration={2} filter={false} words="Hello" /> */}
        <div className="flex space-x-6 mt-3">
          <Link to='/request-demo'>
            <button className="bg-[#7453E0] text-sm text-white font-semibold  px-4 py-2 rounded">Schedule a Live Demo</button>
          </Link>
        </div>
      </div>

      <div className="w-px bg-gray-300 hidden md:block"></div>

      <div className="md:w-1/2 grid grid-cols-1 gap-4">
        <div className="flex space-x-4">
          <div className="text-3xl" style={{ color: "rgb(116, 83, 224)" }}>
            <IoRocketSharp />
          </div>
          <div>
            <h4 className="font-semibold text-lg">D2C Brands	</h4>
            <p className="text-gray-600">
              Convert browsers on WhatsApp, offer post-sale care

            </p>
          </div>
        </div>
        <div className="border-t border-gray-300" />

        <div className="flex space-x-4">
          <div className="text-3xl" style={{ color: "rgb(116, 83, 224)" }}>
            <FaSearch />
          </div>
          <div>
            <h4 className="font-semibold text-lg">Omnichannel Retail	</h4>
            <p className="text-gray-600">
              Connect in-store and online loyalty + campaigns"
            </p>
          </div>
        </div>
        <div className="border-t border-gray-300" />

        <div className="flex space-x-4">
          <div className="text-3xl" style={{ color: "rgb(116, 83, 224)" }}>
            <FaChartLine />
          </div>
          <div>
            <h4 className="font-semibold text-lg">FMCG</h4>
            <p className="text-gray-600">Automate support & reorder reminders"

            </p>
          </div>
        </div>
        <div className="border-t border-gray-300" />

        <div className="flex space-x-4">
          <div className="text-3xl" style={{ color: "rgb(116, 83, 224)" }}>
            <FaTools />
          </div>
          <div>
            <h4 className="font-semibold text-lg">Marketplaces</h4>
            <p className="text-gray-600">
              Enable sellers with conversational storefronts

            </p>
          </div>
        </div>
        <div className="border-t border-gray-300" />

        <div className="flex space-x-4">
          <div className="text-3xl" style={{ color: "rgb(116, 83, 224)" }}>
            <FaChartPie />
          </div>
          <div>
            <h4 className="font-semibold text-lg">Support Teams	</h4>
            <p className="text-gray-600">
              Automate 60% of queries with smart handoff

            </p>
          </div>
        </div>

        <div className="border-t border-gray-300" />

        <div className="flex space-x-4">
          <div className="text-3xl" style={{ color: "rgb(116, 83, 224)" }}>
            <FaGlobe />
          </div>
          <div>
            <h4 className="font-semibold text-lg">Agencies</h4>
            <p className="text-gray-600">Whitelabel VIBE Chat for client deployments
            </p>
          </div>
        </div>

      </div>
    </div>
  </section>
);


const Hero = () => (
  <section className="">
    <div className=" flex items-center flex-col justify-center bg-gradient-to-br from-blue-600 to-indigo-700 text-white p-32 ">
      <p className="text-5xl font-bold text-center">
        <p className='flex items-center text-5xl font-bold text-center'>
          VIBE.AI - The Gen-AI Chatbot That Interacts!
        </p>
        <Typewriter
          words={['Sells & Supports Like a Human.']}
          loop={0}
          cursor
          cursorStyle="|"
          typeSpeed={150}
          deleteSpeed={50}
          delaySpeed={1000}
        />
      </p>

      <p className="text-xl text-center mt-5 p-2" style={{ maxWidth: "70%" }}>
        Meet VIBE - A Gen-AI Chatbot that transforms how your business talks to customers on WhatsApp, your Website, and inside your Mobile App.

      </p>
      <p className="text-2xl mt-6 p-2">
        Handle support | Drive sales | Automate marketing

      </p>

    </div>
  </section>
);

const WhyZeroClick2 = () => (
  <section className="bg-gray-100 py-20 px-6">
    <div className=" mx-auto text-center">
      <div className='d-flex flex-column align-items-center'>

        <div >
          <h1 className="text-6xl font-bold mb-4">VIBE : The AI Agent You Can Count On.  </h1>
          {/* <h5>“Click to Launch. AI to Scale.”</h5> */}
        </div>

        <div style={{ display: "flex", alignItems: "center", flexDirection: "column", gap: "10px" }}>
          <p style={{ textAlign: "center", fontSize: "18px", fontWeight: "400", color: "grey" }}>
            VIBE is an end-to-end conversational AI platform that does what traditional bots can’t: Understand intent, emotion, and urgency
          </p>

          <div className="w-100 flex justify-center gap-4 mt-3">
            <span className='p-2 flex gap-2' style={{ color: "white", borderRadius: "20px", background: "black" }}>
              <Settings style={{ color: "red" }} />
              Frictionless Setup


            </span>
            <span className="p-2 flex gap-2" style={{ color: "white", borderRadius: "20px", background: "black" }}>
              <HandCoins style={{ color: "yellow" }} />
              Revenue-Driven Automation</span>
            <span className="p-2 flex gap-2" style={{ color: "white", borderRadius: "20px", background: "black" }}>
              <MessageCircle style={{ color: "blue" }} />
              Smarter Conversations
            </span>
          </div>

          {/* <h3 className="text-1xl">  0Clik Includes: </h3> */}

          <ul className='hidden' >
            <li className='flex'>
              <ArrowBigRight /> No-code store builder
            </li>
            <li className='flex'>
              <ArrowBigRight /> AI search & product recommendations

            </li>
            <li className='flex'>
              <ArrowBigRight /> Smart pricing & promotion automation

            </li>
            <li className='flex'>
              <ArrowBigRight /> Loyalty & rewards

            </li>
            <li className='flex'>
              <ArrowBigRight /> Chatbot for customer support + AI commerce
            </li>
            <li className='flex'>
              <ArrowBigRight /> Analytics & customer insights
            </li>
            <li className='flex'>
              <ArrowBigRight />  Omnichannel-ready: Web, Android, iOS, PWA
            </li>

          </ul>
          <div className='flex mt-3' style={{ background: "black", color: "white", borderRadius: "20px" }}>


            <div >
              <div style={{ borderBottom: "1px solid grey", padding: "20px" }}>

                <p style={{ fontSize: "20px", textAlign: "start" }}>
                  Solve support issues, not just answer FAQs
                </p>
                <p style={{ textAlign: "start", fontSize: "12px", marginTop: "10px" }}>
                  VIBE goes beyond static FAQ responses by actively resolving customer support issues in real time. It understands user intent and context, enabling more personalized and effective problem-solving.
                </p>

                <div>
                  <div className="voice-feature mt-3">
                    <Rocket className="voice-icon" style={{ color: "#00d084" }} />
                    <span>Resolve customer issues instantly with real-time support.</span>
                  </div>
                  <div className="voice-feature mt-3">
                    <HelpCircle className="voice-icon" style={{ color: "#00d084" }} />
                    <span>Deliver personalized, context-aware solutions — beyond static FAQs.</span>
                  </div>
                </div>
              </div>

              <div>
                <div className="voice-ai-container">
                  <p style={{ fontSize: "20px", textAlign: "start" }}>
                    Sell products with dynamic offers and payment flows
                  </p>
                  <p style={{ textAlign: "start", fontSize: "12px", marginTop: "10px" }}>
                    VIBE enables businesses to sell products through real-time, dynamic offers tailored to customer behavior. It seamlessly integrates payment flows within conversations, creating a frictionless buying experience.
                  </p>
                  <div className="voice-feature mt-3">
                    <BadgeIndianRupee className="voice-icon" style={{ color: "#00d084" }} />
                    <span>Drive sales with real-time, dynamic offers based on customer behavior.</span>
                  </div>
                  <div className="voice-feature">
                    <Gift className="voice-icon" style={{ color: "#00d084" }} />
                    <span>Deliver personalized product recommendations in live conversations.</span>
                  </div>
                  <div className="voice-feature">
                    <ChartPie className="voice-icon" style={{ color: "#00d084" }} />
                    <span>Seamlessly integrate payment flows within chat interactions.</span>
                  </div>
                  <div className="voice-feature">
                    <DollarSign className="voice-icon" style={{ color: "#00d084" }} />
                    <span>Enable instant purchases without leaving the conversation.</span>
                  </div>
                </div>
              </div>
            </div>

            <div style={{ border: "1px solid grey" }}>
              <div style={{ padding: "20px" }}>
                <p style={{ fontSize: "20px", textAlign: "start" }}>
                  Trigger marketing journeys across WhatsApp & web
                </p>
                <p style={{ textAlign: "start", fontSize: "13px", marginTop: "10px" }}>
                  VIBE automates personalized marketing campaigns across WhatsApp and web platforms to drive customer engagement. It ensures timely, contextual messages reach users on their preferred channels for maximum impact.
                </p>
                <div className='mt-3 flex justify-center' >
                  <div
                    style={{
                      backgroundColor: "#1c1c1c",
                      padding: "20px",
                      borderRadius: "12px",
                      width: "350px",
                      fontFamily: "sans-serif",
                      color: "white",
                    }}
                  >
                    {features.map((feature, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          backgroundColor: "#2c2c2c",
                          padding: "10px 15px",
                          borderRadius: "10px",
                          marginBottom: index !== features.length - 1 ? "10px" : "0",
                        }}
                      >
                        <span
                          style={{
                            color: "#00d084",
                            fontSize: "14px",
                            marginRight: "10px",
                          }}
                        >
                          <CircleCheckBig style={{ color: "#00d084", }} />
                        </span>
                        <p style={{ margin: 0, textAlign: "start" }}>{feature.label}</p>
                      </div>
                    ))}
                  </div>

                </div>

              </div>

              <div className='mt-3 hidden'>
                <div className="analytics-container">
                  <p style={{ fontSize: "20px", textAlign: "start" }}>Seamlessly hand off to human agents, with full context
                  </p>
                  <p style={{ textAlign: "start", fontSize: "13px" }}>
                    Help businesses understand user behavior, optimize experiences, and make data-driven decisions for growth.
                  </p>
                  <div className="search-bar">
                    <Search className="search-icon" />
                    <span className="search-placeholder">Type your question</span>
                  </div>
                  <div className="suggestion-box">
                    Which issues frequently lead to escalations?
                  </div>
                </div>
              </div>
            </div>


            <div style={{ padding: "20px" }}>
              <p style={{ fontSize: "20px", textAlign: "start" }}>
                Conversational Commerce – Sell While You Chat
              </p>
              <p style={{ textAlign: "start", fontSize: "13px", marginTop: "10px" }}>
                Conversational commerce lets businesses sell products directly through chat, offering a smooth and personal shopping experience. It combines real-time conversation with instant purchasing.





              </p>

              <div>
                <div className="phone-frame">
                  <div className="chat-container">
                    <div className="bot-message">Hello, how can I assist you today?</div>
                    <div className="user-message">I received a spilled coffee.</div>
                    <div className="bot-message">Please upload an image of the spilled coffee so that I can assist you better.</div>
                    <div className="user-message with-avatar">
                      {/* <img src={spilledCoffee} alt="Spilled Coffee" className="avatar" /> */}
                      <span>hello</span>
                      <span>Sure, here it is.</span>
                    </div>
                    <div className="bot-message">Thanks for the image! I was able to verify the spillage. Would you like a replacement or refund?</div>
                    <div className="user-message">A replacement works for me.</div>
                    <div className="bot-message">Thanks for the confirmation! A replacement order has been placed for you.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
);

const WhyZeroClick = () => (
  <section className="py-20 px-6 bg-gray-100">
    <div className="max-w-5xl mx-auto text-center">
      <div className='flex gap-2'>

        <div style={{ width: "45%" }}>
          <h2 className="text-4xl font-bold mb-4">What is VIBE Chat? </h2>
          <h5>The AI Agent You Can Count On</h5>
        </div>

        <div style={{ width: "55%", display: "flex", alignItems: "start", flexDirection: "column", gap: "10px" }}>
          <p style={{ textAlign: "start", fontSize: "18px", fontWeight: "400" }}>
            VIBE is an end-to-end conversational AI platform that does what traditional bots can’t:
          </p>

          <h3 className="text-1xl"> Understand intent, emotion, and urgency </h3>

          <ul >
            <li className='flex mt-1'>
              <ArrowBigRight /> Solve support issues, not just answer FAQs
            </li>
            <li className='flex mt-1'>
              <ArrowBigRight /> Sell products with dynamic offers and payment flows

            </li>
            <li className='flex mt-1'>
              <ArrowBigRight /> Trigger marketing journeys across WhatsApp & web

            </li>
            <li className='flex mt-1'>
              <ArrowBigRight /> Seamlessly hand off to human agents, with full context
            </li>
          </ul>
        </div>
      </div>

    </div>
  </section>
);

const WhatsApp = () => (
  <section className="py-16 px-20">
    <div className="max-w-5xl mx-auto text-center">
      <h2 className='text-4xl font-bold'>One engine | Every conversation | Anywhere</h2>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-3 gap-5 p-8 bg-white">
      <div class="flex flex-col items-center text-center space-y-2 shadow p-4 py-5 rounded-xl IconHover">
        <div class="p-3 rounded-full shadow-sm" style={{ border: "1px solid #3e3e3e3e" }}>
          <FaWhatsapp className='Social__Icon' size={30} style={{ color: "#7453e0" }} />
        </div>
        <p class="text-md font-bold">WhatsApp Business API</p>
        <p class="text-sm">Automate messaging, enable real-time support, and integrate with CRM and chatbots for seamless customer interactions.</p>
      </div>

      <div class="flex flex-col items-center text-center space-y-2 py-5 shadow p-4 rounded-xl IconHover">
        <div class="p-3 rounded-full shadow-sm" style={{ border: "1px solid #3e3e3e3e" }}>
          <MdWidgets className='Social__Icon' size={30} style={{ color: "#7453e0" }} />
        </div>
        <p class="text-md font-bold">In-Website Widget</p>
        <p class="text-sm">Enhance user engagement with an interactive widget for real-time chat, support, and personalized experiences directly on your website.</p>
      </div>

      <div class="flex flex-col items-center text-center space-y-2 py-5 shadow p-4 rounded-xl IconHover">
        <div class="p-3 rounded-full shadow-sm" style={{ border: "1px solid #3e3e3e3e" }}>
          <MdPhoneIphone className='Social__Icon' size={30} style={{ color: "#7453e0" }} />
        </div>
        <p class="text-md font-bold">In-App SDK for Android/iOS</p>
        <p class="text-sm">Seamlessly integrate chat, support, and automation into your mobile app for a smooth user experience on Android and iOS.</p>
      </div>

      <div class="flex flex-col items-center text-center space-y-2 py-5 shadow p-4 rounded-xl IconHover">
        <div class="p-3 rounded-full shadow-sm" style={{ border: "1px solid #3e3e3e3e" }}>
          <MdAndroid className='Social__Icon' size={30} style={{ color: "#7453e0" }} />
        </div>
        <p class="text-md font-bold">Email & SMS Routing (via fallback)</p>
        <p class="text-sm">Ensure message delivery with intelligent routing, automatically switching between email and SMS based on availability.</p>
      </div>

      <div class="flex flex-col items-center text-center space-y-2 py-5 shadow p-4 rounded-xl IconHover">
        <div class="p-3 rounded-full shadow-sm" style={{ border: "1px solid #3e3e3e3e" }}>
          <FaUserFriends className='Social__Icon' size={30} style={{ color: "#7453e0" }} />
        </div>
        <p class="text-md font-bold">Live Agent Handoff Platforms (e.g., Freshchat, Zendesk, Intercom)</p>
        <p class="text-sm">Seamlessly transfer chats to human agents on platforms like Freshchat, Zendesk, and Intercom for enhanced customer support.</p>
      </div>
    </div>
  </section>
);

const modules = [
  {
    icon: '👗',
    title: 'Customer Support – Human-Like & End-to-End',
    description: [
      '✓ Smart ticket creation & tracking',
      '✓ Conversational NPS, feedback, and post-purchase surveys',
      '✓ Loyalty and referral updates via WhatsApp',
      '✓ AI sentiment detection + smart escalation',
      '✓ Summary view for human agents (intent + emotion + next step)',
    ],
    // badge: '+42% engagement',
    color: '#FF6B6B',
  },

  {
    icon: '💰',
    title: 'Marketing Automation – WhatsApp Campaigns that Work',
    description: [
      '✓ Segmented WhatsApp/SMS/email blasts',
      '✓ Automated journeys based on customer events',
      '✓ A/B test campaigns and flows',
      '✓ Abandoned cart nudges, price drop alerts, win-back flows',
      '✓ Rich media messages (catalogs, videos, carousels)',
    ],
    color: '#4ECDC4',
  },


];


const modules2 = [

  {
    icon: '🛒',
    title: 'Conversational Commerce – Sell While You Chat',
    description: [
      '✓ Smart product discovery',
      '✓ Cross-sell & upsell in real time',
      '✓ Promo codes, offers & cart reminders',
      '✓ One-click checkout + payment link generation',
      '✓ COD, UPI, and wallet options',
      '✓ Back-in-stock alerts & low-stock urgency triggers',
    ],
    color: '#8338EC',
  },

];


const CoreModulesCapabilities2 = () => (
  <section className=" p-5" >
    <div className="core-container" style={{ borderRadius: "20px" }}>
      <div className="core-left">
        <p style={{ fontSize: "25px" }}>Core Modules & Capabilities</p>
        <p className="subtitle">
          A Gen-AI Chatbot that transforms how your business talks
        </p>

        <div className="modules-list">
          {modules.map((mod, i) => (
            <div
              key={i}
              className="module-box"
              style={{ borderLeft: `1px solid ${mod.color}`, border: `1px solid ${mod.color}` }}
            >
              {/* <div className="module-icon">{mod.icon}</div> */}
              <div>
                <h3>{mod.title}</h3>
                <ul>
                  {mod.description.map((item, j) => (
                    <li key={j}>{item}</li>
                  ))}
                </ul>
                {mod.badge && <span className="badge">{mod.badge}</span>}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="core-left">
        <div className="modules-list">
          {modules2.map((mod, i) => (
            <div
              key={i}
              className="module-box"
              style={{ border: `1px solid ${mod.color}` }}
            >
              {/* <div className="module-icon">{mod.icon}</div> */}
              <div>
                <h3>{mod.title}</h3>
                <ul>
                  {mod.description.map((item, j) => (
                    <li key={j}>{item}</li>
                  ))}
                </ul>
                {mod.badge && <span className="badge">{mod.badge}</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

const CoreModulesCapabilities = () => (
  <section className="bg-gray-100 py-20 px-6">
    <div className="max-w-5xl mx-auto text-center">
      <h2 className="text-4xl font-bold mb-8">Core Modules And Capabilities</h2>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-10 text-lg">
        <div className="flex flex-col">
          <div className='flex'>
            <Glasses className="mr-3 text-blue-600 h-6 w-6" />
            <span>Customer Support – Human-Like & End-to-End</span>
          </div>

          <div style={{ textAlign: "start" }}>
            <li className='flex items-center'>   <ArrowBigRight /> Smart ticket creation & tracking </li>
            <li className='flex items-center'>   <ArrowBigRight /> Conversational NPS, feedback, and post-purchase surveys </li>
            <li className='flex items-center'>   <ArrowBigRight /> Loyalty and referral updates via WhatsApp</li>
            <li className='flex items-center'>   <ArrowBigRight /> AI sentiment detection + smart escalation </li>
            <li className='flex items-center'>   <ArrowBigRight /> Summary view for human agents (intent + emotion + next step) </li>
          </div>
        </div>

        <div className="flex flex-col">
          <div className='flex'>
            <Rotate3D className="mr-3 text-blue-600 h-6 w-6" />
            <span> Conversational Commerce – Sell While You Chat</span>
          </div>

          <div style={{ textAlign: "start" }}>
            <li className='flex items-center'>   <ArrowBigRight />Smart product discovery </li>
            <li className='flex items-center'>   <ArrowBigRight /> Cross-sell & upsell in real time
            </li>
            <li className='flex items-center'>   <ArrowBigRight /> Promo codes, offers & cart reminders</li>
            <li className='flex items-center'>   <ArrowBigRight /> One-click checkout + payment link generation </li>

            <li className='flex items-center'>   <ArrowBigRight /> COD, UPI, and wallet options
            </li>
            <li className='flex items-center'>   <ArrowBigRight /> Back-in-stock alerts & low-stock urgency triggers </li>
          </div>
        </div>

        <div className="flex flex-col">
          <div className='flex'>
            <ChartCandlestick className="mr-3 text-blue-600 h-6 w-6" />
            <span className='text-left'>Marketing Automation – WhatsApp Campaigns that Work</span>
          </div>

          <div style={{ textAlign: "start" }}>
            <li className='flex items-start'>   <ArrowBigRight /> Segmented WhatsApp/SMS/email blasts </li>
            <li className='flex items-center'>   <ArrowBigRight /> Automated journeys based on customer events</li>
            <li className='flex items-center'>   <ArrowBigRight /> A/B test campaigns and flows</li>
            <li className='flex items-center'>   <ArrowBigRight /> Abandoned cart nudges, price drop alerts, win-back flows </li>
            <li className='flex items-center'>   <ArrowBigRight />Rich media messages (catalogs, videos, carousels) </li>
          </div>
        </div>
      </ul>
    </div>
  </section>
);

const UseCases = () => (
  // <section className="py-20 pt-8 px-6 bg-gray-100 ">
  //   <div className="max-w-5xl mx-auto text-center">
  //     <h2 className="text-4xl font-bold mb-12">Powered by Generative AI
  //     </h2>
  //     <ul className="grid grid-cols-1 sm:grid-cols-2 gap-5 text-lg">
  //       <li className="shadow-md p-4 rounded rounded-lg border card text-start flex items-center justify-start"><FaCommentDots className="mr-3 text-blue-600 h-6 w-6" /> Understands slang, local dialects, typos.
  //       </li>
  //       <li className="shadow-md p-4 rounded rounded-lg border text-start flex items-center justify-start"><FaSmile className="mr-3 text-blue-600 h-6 w-6" /> Knows when to joke, when to apologize, when to hand off.</li>
  //       <li className="shadow-md p-4 rounded rounded-lg border text-start flex items-center justify-start"><FaFileAlt className="mr-3 text-blue-600 h-6 w-6" /> Writes campaign copy, summaries, and replies in real time.</li>
  //       <li className="shadow-md p-4 rounded rounded-lg border text-start flex items-center justify-start"><User className="mr-3 text-blue-600 h-6 w-6" /> Continuously learns from user interactions & outcomes.</li>
  //     </ul>
  //   </div>
  // </section>


  <section className="py-20 px-6 bg-gray-100">
    <div className="max-w-6xl mx-auto text-center">
      <h2 className="text-4xl font-bold mb-4">Powered by AI</h2>
      <p className="text-xl mb-12 text-gray-600">AI-First Solutions To Hack Ecommerce Growth</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
        <div className="space-y-8 text-left flex flex-col" style={{ gap: "8rem" }}>
          <div className='flex flex-col p-5 rounded-lg border'>
            {/* <FaCommentDots className="mr-3 text-blue-600 h-6 w-6" /> */}
            <p className="text-dark text-lg text-center">Understands slang, local dialects, typos</p>
            <p className="text-gray-600 text-sm text-center">This AI is capable of understanding casual slang, regional dialects, and common typos, making it easy to communicate naturally without worrying about perfect grammar or spelling.
            </p>
          </div>
          <div className='flex flex-col p-5 rounded-lg border'>
            {/* <FaSmile className="mr-3 text-blue-600 h-6 w-6" /> */}
            <p className="text-dark text-lg text-center">Knows when to joke, when to apologize, when to hand off.</p>
            <p className="text-gray-600 text-sm text-center">The AI understands context—knowing when to make a joke, offer an apology, or hand off to a human—ensuring conversations stay appropriate, helpful, and human-like.


</p>
          </div>
        </div>
        <div className="flex">
          <img src="/imageBg.png" alt="AI Robot" className="w-100 h-auto" />
        </div>
        <div className="space-y-8 text-left flex flex-col" style={{ gap: "8rem" }}>
          <div className='flex flex-col p-5 rounded-lg border'>
            {/* <FaFileAlt className="mr-3 text-blue-600 h-6 w-6" /> */}
            <p className="text-dark text-lg text-center">Writes campaign copy, summaries, and replies in real time.</p>
            <p className="text-gray-600 text-sm text-center">The AI can quickly write campaign copy, summarize content, and generate replies in real time, helping you stay efficient and responsive without spending hours crafting the perfect message.
            </p>
          </div>
          <div className='flex flex-col p-5 rounded-lg border'>
          
            <p className="text-dark text-lg text-center">Continuously learns from user interactions & outcomes.</p>
            <p className="text-gray-600 text-sm text-center">The AI continuously learns from user interactions and outcomes, allowing it to adapt, improve responses, and deliver more personalized and accurate assistance over time.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

);

const Benefits = () => (
  <section className="bg-gray-100 py-20 px-6">
    <div className="max-w-5xl mx-auto text-center">
      <h2 className="text-4xl font-bold mb-12">Feature Snapshot</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="font-bold  text-xl mb-2 flex items-center gap-2 justify-center ">  <FaHandsHelping style={{ color: "#7453e0" }} /> Support</h3>
          <p className="text-gray-700">Track tickets, measure NPS, collect feedback, and streamline live agent routing for better customer support.</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="font-bold  text-xl mb-2 flex items-center gap-2 justify-center">  <FaShoppingCart style={{ color: "#7453e0" }} /> Commerce</h3>
          <p className="text-gray-700">Enhance shopping experiences with product search, seamless carts, and secure payments.</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="font-bold  text-xl mb-2 flex items-center gap-2 justify-center">  <FaChartBar style={{ color: "#7453e0" }} /> Marketing</h3>
          <p className="text-gray-700">Create targeted experiences with a campaign builder, automated journeys, and deep personalization.</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="font-bold  text-xl mb-2 flex items-center gap-2 justify-center">  <FaCogs style={{ color: "#7453e0" }} /> AI Core</h3>
          <p className="text-gray-700">Leverage NLP for smart conversations, intent/emotion detection for better understanding, and memory for personalized interactions.</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="font-bold text-xl mb-2 flex items-center gap-2 justify-center">  <FaMobileAlt style={{ color: "#7453e0" }} /> Channels</h3>
          <p className="text-gray-700">Engage customers across WhatsApp, Web, App, Email, and SMS for seamless, multi-channel communication.</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="font-bold  text-xl mb-2 flex items-center gap-2 justify-center">  <FaChartPie style={{ color: "#7453e0" }} /> Analytics</h3>
          <p className="text-gray-700">Enhance support resolution rates, measure CSAT, and optimize performance with detailed conversion reports.</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="font-bold  text-xl mb-2 flex items-center gap-2 justify-center"> <FaShieldAlt style={{ color: "#7453e0" }} />  Security</h3>
          <p className="text-gray-700">Ensure security with role-based access, protect data with encryption, and stay GDPR-ready for compliance.</p>
        </div>
      </div>
    </div>
  </section>
);

const TableUI = () => (
  <section className=" text-black py-14 px-6">
    <div className="text-center mb-5">
      <h2 className="text-4xl font-bold text-black">Who should use it?</h2>
    </div>

    <div className="overflow-x-auto max-w-4xl mx-auto">
      <table className="min-w-full table-auto border border-gray-300 bg-white shadow-md rounded-lg">
        <thead className="bg-indigo-600 text-white rounded-sm">
          <tr>
            <th className="text-center px-6 py-4 font-semibold text-lg">Business Type</th>
            <th className="text-center px-6 py-4 font-semibold text-lg">Use Case</th>
          </tr>
        </thead>
        <tbody className="text-gray-800">
          <tr className="border-t">
            <td className="px-6 py-4 text-center">D2C Brands</td>
            <td className="px-6 py-4 text-center">Convert browsers on WhatsApp, offer post-sale care</td>
          </tr>
          <tr className="border-t">
            <td className="px-6 py-4 text-center">Omnichannel Retail</td>
            <td className="px-6 py-4 text-center">Connect in-store and online loyalty + campaigns</td>
          </tr>
          <tr className="border-t">
            <td className="px-6 py-4 text-center">FMCG</td>
            <td className="px-6 py-4 text-center">Automate support & reorder reminders</td>
          </tr>
          <tr className="border-t">
            <td className="px-6 py-4 text-center">Marketplaces</td>
            <td className="px-6 py-4 text-center">Enable sellers with conversational storefronts</td>
          </tr>
          <tr className="border-t">
            <td className="px-6 py-4 text-center">Support Teams</td>
            <td className="px-6 py-4 text-center">Automate 60% of queries with smart handoff</td>
          </tr>
          <tr className="border-t">
            <td className="px-6 py-4 text-center">Agencies</td>
            <td className="px-6 py-4 text-center">Whitelabel VIBE Chat for client deployments</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
)

const RequestDemo = () => (
  <section className="bg-gradient-to-br from-blue-600 to-indigo-700 text-white py-20 px-6 hidden">
    <div className="max-w-5xl mx-auto text-center">
      <Link to="/request-demo">
        <button
          type="submit"
          className="inline-flex items-center px-8 py-4 bg-white text-blue-600 font-semibold rounded-full shadow-lg hover:bg-gray-100 transition duration-300 text-lg"
        >
          <Rocket className="mr-2 h-6 w-6" />Request a Demo
        </button>
      </Link>
    </div>
  </section>
);